export default "__VITE_ASSET__Zk$EG50d__"